import React from 'react';
import './Footer.css'; 

export default function Footer(){
    return(
        <nav className="foot">
            <div className="foot-text-container">
                <p className='foot-text'>
                    Thank you for viewing my portfolio!&nbsp;
                </p>
                <p className='foot-text'>
                    If you have any questions, you can reach out to me on my socials.
                </p>
            </div>
        </nav>
    );
};
